import { useQuery } from '@tanstack/react-query';
import * as loginServices from 'services/login';
import { setSession } from 'utils/common/session';
import { logout } from 'utils/common/route';

export const keys = {
  refreshToken: ['get-refresh-token'],
};

export const useGetRefreshToken = (options) => {
  const query = useQuery({
    queryKey: keys.refreshToken,
    queryFn: async () => {
      let refreshToken = localStorage.getItem('RefreshToken');
      const response = await loginServices.getRefreshToken({
        token: refreshToken,
      });

      const { isSuccess, data } = response || {};

      if (isSuccess) {
        const { access_token, refresh_token, '.expires': expTime } = data;

        setSession(access_token, refresh_token, expTime);
        return data;
      } else {
        logout();
      }
    },
    ...options,
  });

  return query;
};
